var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _circle, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle2, _path42, _path43, _path44, _path45, _circle3, _path46, _path47, _path48, _path49, _path50, _circle4, _path51, _path52, _path53, _circle5, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _circle6, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollabIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ill_devin-o_partener",
    "data-name": "Ill devin-o partener",
    xmlns: "http://www.w3.org/2000/svg",
    width: 496,
    height: 334,
    viewBox: "0 0 496 334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28874",
    "data-name": "Path 28874",
    d: "M197.405,562.436c-2.382,0-4.768.115-7.1.348l-.339.034c-15.46,1.6-26.767,10.91-26.3,21.647l.09,1.941c.059,1.227.122,2.547.174,4.011.028.722.867,1.276,1.912,1.276l380.75,38.688c26.811-.191,53.524-.431,79.394-.715a115.318,115.318,0,0,0,14.526-.883c7.189-1,12.179-2.978,15.256-6.052,6.138-5.952,2.966-7.229,3.717-14.035-.471-10.95-1.422-61.141-1.889-72.61-.412-10.108-.822-20.188-1.232-29.839-.254-5.727-.817-10.783-5.163-14.647-4.71-4.179-13.3-6.3-25.532-6.3h-.444c-38.333.16-76.315,15.631-94.513,38.5-2.1,2.633-4.048,5.452-5.937,8.179a106.946,106.946,0,0,1-9.118,11.916,44.6,44.6,0,0,1-6.023,5.511c-.148.12-.317.248-.5.37-.409.313-.837.615-1.254.883a40.782,40.782,0,0,1-7.681,4.1l-.269.106c-.2.085-.422.17-.642.248a44.481,44.481,0,0,1-4.744,1.488,65.318,65.318,0,0,1-23.443,1.277A98.8,98.8,0,0,1,447.8,552.3a238.265,238.265,0,0,1-22.676-10.221c-3.173-1.569-6.456-3.19-9.733-4.726-.616-.289-1.222-.572-1.837-.854-4-1.831-7.633-3.344-11.1-4.624a95.183,95.183,0,0,0-26.442-5.748c-9.534-.613-17.935.543-24.965,3.426a39.831,39.831,0,0,0-5.647,2.856c-8.327,5.075-13.46,12.566-18.423,19.809-6.175,9.01-12.56,18.328-25.168,23.158-14.548,5.579-35.784,3.261-50.808-.769-4.724-1.267-9.441-2.725-14-4.136q-2.764-.855-5.532-1.7c-3.626-1.1-6.594-1.941-9.34-2.651l-.868-.227c-.483-.123-.967-.246-1.459-.364-3.261-.8-6.3-1.436-9.289-1.934l-.708-.121c-1.419-.219-2.745-.4-4.046-.555l-.52-.061A70.892,70.892,0,0,0,197.405,562.436Z",
    transform: "translate(-163.651 -298.633)",
    fill: "#F2B920"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28875",
    "data-name": "Path 28875",
    d: "M890.642,608.882c10.569-9.524,26.289-14.313,39.475-8.972a65.549,65.549,0,0,0-29.456,34.024c-2.1,5.585-3.853,12.016-9.016,15.006-3.213,1.861-7.21,1.952-10.812,1.053a43.521,43.521,0,0,1-10.161-4.482l-.927-.021C873.906,631.886,880.073,618.406,890.642,608.882Z",
    transform: "translate(-468.903 -347.367)",
    fill: "#991f1f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28876",
    "data-name": "Path 28876",
    d: "M930.157,601.632a56.028,56.028,0,0,0-31.17,14.72,24.13,24.13,0,0,0-4.738,5.891,13.837,13.837,0,0,0-1.6,7.1c.057,2.3.382,4.654-.122,6.932a8.473,8.473,0,0,1-4.215,5.5,22.013,22.013,0,0,1-8.451,2.308c-3.231.4-6.594.756-9.391,2.569-.339.22-.66-.319-.321-.538,4.866-3.153,11.024-2.006,16.257-4.11a8.581,8.581,0,0,0,5.367-5.312c.669-2.279.335-4.7.257-7.035a14.766,14.766,0,0,1,1.305-7.005,22.3,22.3,0,0,1,4.494-6.051,54.356,54.356,0,0,1,13.814-9.889,57.021,57.021,0,0,1,18.507-5.71c.4-.052.4.576.006.627Z",
    transform: "translate(-469.016 -348.8)",
    fill: "#77191a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28877",
    "data-name": "Path 28877",
    d: "M924.469,614.855a8.406,8.406,0,0,1,.927-10.845c.287-.283.741.15.453.434a7.783,7.783,0,0,0-.841,10.09C925.243,614.861,924.7,615.181,924.469,614.855Z",
    transform: "translate(-491.887 -349.839)",
    fill: "#77191a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28878",
    "data-name": "Path 28878",
    d: "M909.278,647.08a16.2,16.2,0,0,0,11.577-2.318c.34-.218.661.32.321.538a16.852,16.852,0,0,1-12.052,2.388C908.727,647.616,908.882,647.009,909.278,647.08Z",
    transform: "translate(-485.827 -367.695)",
    fill: "#77191a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28879",
    "data-name": "Path 28879",
    d: "M953.215,607.225A4.758,4.758,0,0,0,956.773,610c.4.067.243.674-.153.608a5.332,5.332,0,0,1-3.944-3.065.324.324,0,0,1,.109-.43.315.315,0,0,1,.43.108Z",
    transform: "translate(-504.738 -351.189)",
    fill: "#77191a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28880",
    "data-name": "Path 28880",
    d: "M944.064,669.736c-.25-.035-.5-.069-.754-.1a62.649,62.649,0,0,0-10.151-.516c-.262,0-.528.012-.79.023a66.056,66.056,0,0,0-23.7,5.456,64.154,64.154,0,0,0-8.608,4.573c-3.8,2.4-7.722,5.312-11.966,6.293a10.993,10.993,0,0,1-1.341.239l-17.535-15.183c-.023-.055-.049-.105-.071-.16l-.728-.574c.135-.1.278-.2.414-.3.078-.058.161-.113.239-.171.053-.038.107-.075.153-.112l.05-.034c.046-.037.093-.067.136-.1q1.194-.846,2.4-1.677s0,0,.011,0a94.32,94.32,0,0,1,19.643-10.559c.208-.079.42-.161.636-.233a61.208,61.208,0,0,1,9.616-2.706,54.089,54.089,0,0,1,5.423-.757,45,45,0,0,1,14.035.994c9.164,2.125,17.547,7.157,22.512,15.005C943.818,669.334,943.941,669.531,944.064,669.736Z",
    transform: "translate(-468.33 -371.264)",
    fill: "#991f1f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28881",
    "data-name": "Path 28881",
    d: "M944.122,676.761a56.027,56.027,0,0,0-33.75-7.013,24.125,24.125,0,0,0-7.329,1.851,13.837,13.837,0,0,0-5.555,4.71c-1.341,1.874-2.5,3.946-4.27,5.461a8.473,8.473,0,0,1-6.677,1.854,22.015,22.015,0,0,1-8.137-3.245c-2.818-1.629-5.72-3.366-9.045-3.6-.4-.029-.335-.652.067-.623,5.784.412,10.01,5.036,15.455,6.506a8.581,8.581,0,0,0,7.483-1.01c1.906-1.417,3.1-3.553,4.441-5.462a14.767,14.767,0,0,1,5.26-4.808,22.308,22.308,0,0,1,7.231-2.126,54.356,54.356,0,0,1,16.983.421,57.021,57.021,0,0,1,18.214,6.583c.35.2-.026.7-.373.5Z",
    transform: "translate(-468.62 -378.1)",
    fill: "#77191a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28882",
    "data-name": "Path 28882",
    d: "M948.408,663.2a8.406,8.406,0,0,1,7.269-8.1c.4-.053.5.566.1.619a7.784,7.784,0,0,0-6.747,7.55C949.023,663.675,948.4,663.606,948.408,663.2Z",
    transform: "translate(-502.91 -372.187)",
    fill: "#77191a"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28883",
    "data-name": "Path 28883",
    d: "M919.659,680.132a16.2,16.2,0,0,0,10.64,5.12c.4.03.335.653-.068.623a16.852,16.852,0,0,1-11.061-5.35C918.9,680.228,919.385,679.837,919.659,680.132Z",
    transform: "translate(-490.235 -382.963)",
    fill: "#77191a"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28884",
    "data-name": "Path 28884",
    d: "M979.727,673.32a4.758,4.758,0,0,0,1.169,4.361c.278.293-.212.684-.489.393a5.332,5.332,0,0,1-1.3-4.822.324.324,0,0,1,.345-.278.315.315,0,0,1,.278.346Z",
    transform: "translate(-516.123 -379.914)",
    fill: "#77191a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28885",
    "data-name": "Path 28885",
    d: "M409.93,618.211c8.654-13.126,24.135-22.621,39.724-20.578a72.439,72.439,0,0,0-22.039,44.585c-.691,6.557-.778,13.923-5.468,18.558-2.918,2.884-7.168,4.093-11.271,4.135s-8.135-.966-12.114-1.966l-1,.235C398.429,647.47,401.276,631.337,409.93,618.211Z",
    transform: "translate(-264.861 -347.223)",
    fill: "#991f1f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28886",
    "data-name": "Path 28886",
    d: "M449.651,597.9a61.916,61.916,0,0,0-29.242,24.415,26.665,26.665,0,0,0-3.428,7.618,15.293,15.293,0,0,0,.266,8.044c.7,2.448,1.7,4.871,1.8,7.447a9.364,9.364,0,0,1-2.978,7.055c-2.347,2.3-5.383,3.628-8.4,4.819-3.346,1.323-6.842,2.643-9.329,5.36-.3.329-.795-.158-.494-.486,4.328-4.726,11.233-5.212,16.244-8.919,2.338-1.73,4.169-4.174,4.262-7.174.081-2.623-.95-5.123-1.682-7.6a16.319,16.319,0,0,1-.553-7.856,24.649,24.649,0,0,1,3.123-7.722,60.07,60.07,0,0,1,12.023-14.42,63.011,63.011,0,0,1,18.2-11.256c.413-.166.591.5.181.669Z",
    transform: "translate(-264.857 -347.156)",
    fill: "#77191a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28887",
    "data-name": "Path 28887",
    d: "M438.7,625.8a9.289,9.289,0,0,1-2.026-11.857c.229-.383.834-.045.605.338a8.6,8.6,0,0,0,1.907,11.026C439.528,625.59,439.04,626.082,438.7,625.8Z",
    transform: "translate(-281.12 -354.12)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28888",
    "data-name": "Path 28888",
    d: "M430.925,662.495a17.9,17.9,0,0,0,11.737-5.7c.3-.328.8.159.494.486a18.623,18.623,0,0,1-12.226,5.907c-.445.034-.448-.659-.005-.693Z",
    transform: "translate(-279.053 -372.872)",
    fill: "#77191a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28889",
    "data-name": "Path 28889",
    d: "M466.323,610.147a5.258,5.258,0,0,0,4.579,1.982c.445-.04.447.654.005.693a5.892,5.892,0,0,1-5.071-2.181.358.358,0,0,1,0-.49A.348.348,0,0,1,466.323,610.147Z",
    transform: "translate(-294.246 -352.479)",
    fill: "#77191a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28890",
    "data-name": "Path 28890",
    d: "M477.432,669.38c-.277.033-.554.065-.834.1a69.246,69.246,0,0,0-11,2.273c-.28.077-.562.159-.839.244a73,73,0,0,0-23.831,12.429,70.9,70.9,0,0,0-7.934,7.286c-3.392,3.627-6.781,7.83-11.047,10.059a12.165,12.165,0,0,1-1.368.629L397.6,691.042c-.039-.052-.081-.1-.121-.151l-.938-.412c.117-.144.242-.291.359-.436.068-.084.14-.165.208-.249.047-.055.094-.11.133-.163.015-.018.031-.037.044-.05.039-.052.081-.1.117-.144q1.042-1.237,2.1-2.463c0-.005,0-.005.01-.008a104.242,104.242,0,0,1,18.071-16.757c.2-.142.4-.29.615-.426a67.64,67.64,0,0,1,9.532-5.569,59.82,59.82,0,0,1,5.589-2.319,49.732,49.732,0,0,1,15.288-2.841c10.393-.277,20.758,2.773,28.252,9.786C477.057,669.018,477.243,669.2,477.432,669.38Z",
    transform: "translate(-264.332 -373.888)",
    fill: "#991f1f"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28891",
    "data-name": "Path 28891",
    d: "M477.506,675.587a61.916,61.916,0,0,0-38.048,1.889,26.664,26.664,0,0,0-7.324,4.019,15.292,15.292,0,0,0-4.631,6.583c-.913,2.377-1.573,4.915-3.048,7.029a9.364,9.364,0,0,1-6.625,3.84c-3.262.427-6.482-.344-9.605-1.207-3.468-.958-7.054-2.009-10.676-1.337-.439.081-.539-.6-.1-.686,6.3-1.168,12.107,2.6,18.34,2.659,2.908.027,5.842-.823,7.723-3.162,1.644-2.046,2.326-4.662,3.23-7.077a16.318,16.318,0,0,1,4.288-6.605,24.649,24.649,0,0,1,7.142-4.286,60.069,60.069,0,0,1,18.281-4.274,63.014,63.014,0,0,1,21.312,1.973C478.195,675.06,477.933,675.7,477.506,675.587Z",
    transform: "translate(-264.602 -379.829)",
    fill: "#77191a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28892",
    "data-name": "Path 28892",
    d: "M478.232,669.872a9.289,9.289,0,0,1,5.521-10.687c.413-.168.693.466.28.634a8.6,8.6,0,0,0-5.115,9.952C479.02,670.2,478.333,670.3,478.232,669.872Z",
    transform: "translate(-299.544 -373.941)",
    fill: "#77191a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28893",
    "data-name": "Path 28893",
    d: "M450.717,697.453a17.9,17.9,0,0,0,12.8,2.515c.439-.08.54.606.1.686a18.623,18.623,0,0,1-13.318-2.645C449.927,697.768,450.342,697.213,450.717,697.453Z",
    transform: "translate(-287.51 -390.471)",
    fill: "#77191a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28894",
    "data-name": "Path 28894",
    d: "M513.174,673.433a5.258,5.258,0,0,0,2.463,4.339c.379.236-.037.791-.413.556a5.892,5.892,0,0,1-2.735-4.794.358.358,0,0,1,.292-.393.348.348,0,0,1,.393.292Z",
    transform: "translate(-314.456 -379.985)",
    fill: "#77191a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28895",
    "data-name": "Path 28895",
    d: "M520.435,420.957a5.541,5.541,0,0,0-.728-8.465l9.044-43.773-9.758,3.078-7.277,42.346a5.571,5.571,0,0,0,8.718,6.813Z",
    transform: "translate(-313.774 -247.791)",
    fill: "#facca8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28896",
    "data-name": "Path 28896",
    d: "M542.867,251.152l-6.044-4.563s-5.332-.378-6.277,9.238-6.857,46.522-6.857,46.522l-9.249,42.839,12.8,2.81,9.907-46.231,9.917-31.895Z",
    transform: "translate(-315.3 -194.774)",
    fill: "#f5f5f5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28897",
    "data-name": "Path 28897",
    d: "M533.689,354.83l-28.995-22.545a2.162,2.162,0,0,1-.379-3.031l19.728-25.372a2.162,2.162,0,0,1,3.031-.379l28.995,22.545a2.162,2.162,0,0,1,.379,3.031l-19.728,25.372A2.162,2.162,0,0,1,533.689,354.83Z",
    transform: "translate(-310.727 -219.261)",
    fill: "#991f1f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28898",
    "data-name": "Path 28898",
    d: "M535.352,354.312,508.817,333.68a1.92,1.92,0,0,1-.337-2.691l17.884-23a1.92,1.92,0,0,1,2.691-.337l26.535,20.632a1.92,1.92,0,0,1,.337,2.691l-17.884,23a1.92,1.92,0,0,1-2.691.337Z",
    transform: "translate(-312.55 -221.08)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28899",
    "data-name": "Path 28899",
    d: "M515.367,343.288a.48.48,0,0,1-.084-.673l9.022-11.6a.479.479,0,1,1,.757.588l-9.022,11.6A.48.48,0,0,1,515.367,343.288Z",
    transform: "translate(-315.622 -231.282)",
    fill: "#e4e4e4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28900",
    "data-name": "Path 28900",
    d: "M518,345.336a.48.48,0,0,1-.084-.673l9.022-11.6a.479.479,0,0,1,.757.588l-9.022,11.6A.48.48,0,0,1,518,345.336Z",
    transform: "translate(-316.761 -232.172)",
    fill: "#e4e4e4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28901",
    "data-name": "Path 28901",
    d: "M529.639,340.811a.48.48,0,0,1-.084-.673l3.911-5.03a.479.479,0,1,1,.757.589l-3.911,5.03A.48.48,0,0,1,529.639,340.811Z",
    transform: "translate(-321.792 -233.054)",
    fill: "#e4e4e4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28902",
    "data-name": "Path 28902",
    d: "M533.191,348.078a.48.48,0,0,1-.084-.673l14.243-18.318a.479.479,0,0,1,.757.588l-14.243,18.318A.48.48,0,0,1,533.191,348.078Z",
    transform: "translate(-323.327 -230.454)",
    fill: "#e4e4e4"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28903",
    "data-name": "Path 28903",
    d: "M535.825,350.126a.48.48,0,0,1-.084-.673l14.243-18.318a.479.479,0,1,1,.757.589L536.5,350.042a.48.48,0,0,1-.673.084Z",
    transform: "translate(-324.466 -231.343)",
    fill: "#e4e4e4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28904",
    "data-name": "Path 28904",
    d: "M541.8,354.775a.48.48,0,0,1-.084-.673l14.243-18.318a.479.479,0,1,1,.757.588l-14.243,18.318A.48.48,0,0,1,541.8,354.775Z",
    transform: "translate(-327.051 -233.361)",
    fill: "#e4e4e4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28905",
    "data-name": "Path 28905",
    d: "M544.438,356.823a.48.48,0,0,1-.084-.673L558.6,337.833a.479.479,0,1,1,.757.589L545.11,356.739A.48.48,0,0,1,544.438,356.823Z",
    transform: "translate(-328.189 -234.251)",
    fill: "#e4e4e4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28906",
    "data-name": "Path 28906",
    d: "M550.417,361.472a.48.48,0,0,1-.084-.673l14.243-18.318a.479.479,0,1,1,.757.588L551.09,361.388A.48.48,0,0,1,550.417,361.472Z",
    transform: "translate(-330.774 -236.269)",
    fill: "#e4e4e4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28907",
    "data-name": "Path 28907",
    d: "M553.051,363.52a.48.48,0,0,1-.084-.673L567.21,344.53a.479.479,0,1,1,.757.588l-14.243,18.318A.48.48,0,0,1,553.051,363.52Z",
    transform: "translate(-331.913 -237.158)",
    fill: "#e4e4e4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_445",
    "data-name": "Ellipse 445",
    cx: 0.197,
    cy: 0.197,
    r: 0.197,
    transform: "translate(197.137 147.137)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28908",
    "data-name": "Path 28908",
    d: "M557.783,167.283a47.392,47.392,0,0,1-3.381,10.792c-8.9,18.823,16.441,12.687,25.5,12.687,9.9,0,19.373,5.206,17.926-17.926-.618-9.881-8.026-17.926-17.926-17.926C571.441,154.909,559.551,158.668,557.783,167.283Z",
    transform: "translate(-331.77 -154.909)",
    fill: "#1d1d26"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28909",
    "data-name": "Path 28909",
    d: "M443.859,483.308h-8.435l-4.014-32.536h12.449Z",
    transform: "translate(-186.503 -195.913)",
    fill: "#facca8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28910",
    "data-name": "Path 28910",
    d: "M602.334,672.6h-6.049l-1.08-5.711-2.765,5.711H576.4a3.607,3.607,0,0,1-2.049-6.574l12.812-8.849V651.4l13.476.8Z",
    transform: "translate(-340.525 -370.588)",
    fill: "#1d1d26"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28911",
    "data-name": "Path 28911",
    d: "M519.225,469.451l-6.769,5.034L489.82,450.771l9.99-7.429Z",
    transform: "translate(-211.755 -192.523)",
    fill: "#facca8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28912",
    "data-name": "Path 28912",
    d: "M706.687,648.532l-4.854,3.61-4.274-3.939,1.189,6.233-12.875,9.574a3.607,3.607,0,0,1-5.568-4.053l5-14.746-3.445-4.633,11.294-7.4Z",
    transform: "translate(-386.923 -362.712)",
    fill: "#1d1d26"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28913",
    "data-name": "Path 28913",
    d: "M404.675,221.321l40.042-6.237-7.963-23.955H404.675Z",
    transform: "translate(-174.945 -82.997)",
    fill: "#facca8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28914",
    "data-name": "Path 28914",
    d: "M604.007,367.291s16,13.827,8.62,53.245l-9.015,38.623L628.173,501.8l-12.489,6.812-30.268-42.069-13.851-32.489-7.326-56.94Z",
    transform: "translate(-336.83 -247.371)",
    fill: "#1d1d26"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28915",
    "data-name": "Path 28915",
    d: "M426.209,346.3l-.963,14.908,2.818,44.146,13.99,4.817L444.7,364.94Z",
    transform: "translate(-183.839 -150.463)",
    fill: "#1d1d26"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28916",
    "data-name": "Path 28916",
    d: "M569.167,226.8l15.478.6,6.169,10.24,14.074,2.747-8.4,42.5,1.545,24.193-14.014-.085a40.991,40.991,0,0,0-27.427,10.3h0l.419-31.4-6.028-23.443,1.355-24.582,11.322-1.415Z",
    transform: "translate(-331.098 -185.991)",
    fill: "#f5f5f5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_446",
    "data-name": "Ellipse 446",
    cx: 14.567,
    cy: 14.567,
    r: 14.567,
    transform: "translate(232.077 6.714)",
    fill: "#facca8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28917",
    "data-name": "Path 28917",
    d: "M574.608,164.382a16.686,16.686,0,0,1,25.369,14.563c-7.423,1.864-15.221,3.29-23.137.446l-1.869-4.575-1.1,4.579c-2.411.985-4.828,1.819-7.244-.01A17.038,17.038,0,0,1,574.608,164.382Z",
    transform: "translate(-337.857 -157.95)",
    fill: "#1d1d26"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28918",
    "data-name": "Path 28918",
    d: "M641.12,417.827l1.964,17.821a2.175,2.175,0,0,0,2.079,1.536h9.052a2.175,2.175,0,0,0,2.079-1.536l1.626-13.659a3.3,3.3,0,1,0,.852-6.214,2.156,2.156,0,0,0-1.65-.763H643.2a2.176,2.176,0,0,0-2.079,2.815Zm17.085,3.238,1-3.238a2.152,2.152,0,0,0,.033-1.151c.043,0,.083-.013.126-.013a2.359,2.359,0,1,1,0,4.717A2.329,2.329,0,0,1,658.2,421.065Z",
    transform: "translate(-370.024 -267.845)",
    fill: "#c72828"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28919",
    "data-name": "Path 28919",
    d: "M659.106,414.278a5.541,5.541,0,0,1,.771-8.461L651.055,362l9.742,3.128,7.062,42.383a5.571,5.571,0,0,1-8.752,6.768Z",
    transform: "translate(-374.361 -244.871)",
    fill: "#facca8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28920",
    "data-name": "Path 28920",
    d: "M632.094,255.307l6.045-4.563s5.332-.378,6.277,9.238,6.857,46.522,6.857,46.522l9.249,42.839-12.8,2.81-9.907-46.231-9.917-31.9Z",
    transform: "translate(-364.348 -196.581)",
    fill: "#f5f5f5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_447",
    "data-name": "Ellipse 447",
    cx: 3.422,
    cy: 3.422,
    r: 3.422,
    transform: "translate(212.155 91.721)",
    fill: "#c72828"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28921",
    "data-name": "Path 28921",
    d: "M187.544,557.061h7.131l3.393-27.5H187.543Z",
    transform: "translate(-81.077 -229.973)",
    fill: "#facca8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28922",
    "data-name": "Path 28922",
    d: "M347.992,726.387H350l7.836-3.187,4.2,3.186h0a8.95,8.95,0,0,1,8.949,8.949v.291H347.992Z",
    transform: "translate(-243.343 -401.627)",
    fill: "#1d1d26"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28923",
    "data-name": "Path 28923",
    d: "M236.221,549.659l6.956,1.571,9.367-26.081-10.266-2.318Z",
    transform: "translate(-102.121 -227.065)",
    fill: "#facca8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28924",
    "data-name": "Path 28924",
    d: "M396.1,719.577l1.958.442,8.346-1.382,3.395,4.033h0a8.95,8.95,0,0,1,6.758,10.7l-.064.284-22.428-5.064Z",
    transform: "translate(-263.261 -399.655)",
    fill: "#1d1d26"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28925",
    "data-name": "Path 28925",
    d: "M328.2,474.356l6.448,72.244s-2.416,43.372,5.38,58.634h11.307l5.6-62.6.7-42.014,24.24,35.446-15.439,68.14,13.916,1.244,25.054-73.948-27.525-69.42Z",
    transform: "translate(-234.787 -288.746)",
    fill: "#1d1d26"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 16.629,
    cy: 16.629,
    r: 16.629,
    transform: "translate(83.537 38.345)",
    fill: "#facca8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28926",
    "data-name": "Path 28926",
    d: "M349.307,299.134l-13.642-5.854-6.641-7.044-16.591,2.676-4.4,7.548-14.25,13.25,16.7,75.487-.505,16.487s10.685,4.81,57.026-6.265c.556-.133-.608-.714-.608-.714Z",
    transform: "translate(-219.907 -212.038)",
    fill: "#f5f5f5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28927",
    "data-name": "Path 28927",
    d: "M309.272,268.005q-.174-.237-.344-.478c-.046.1-.082.2-.134.291Z",
    transform: "translate(-226.397 -203.595)",
    fill: "#2f2e41"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28928",
    "data-name": "Path 28928",
    d: "M342.718,224.232a10.611,10.611,0,0,0-5.552-5.364,10.13,10.13,0,0,0-7.6.007,15.3,15.3,0,0,0-7.214-2.626,8.068,8.068,0,0,0-6.878,2.919,11.229,11.229,0,0,1-1.2,1.561c-1.274,1.18-3.211,1.01-4.9.769l2.28,1.953-2.759.721,3.219,1.953c-3.115,1.87-4.531,5.951-4.157,9.658a20.425,20.425,0,0,0,4.074,9.571c.808-1.705.634-3.745.621-5.666-.014-2.029.345-4.333,1.971-5.467a6.507,6.507,0,0,1,3.83-.792,175.95,175.95,0,0,1,19.96,1.246,5.619,5.619,0,0,1,2.555.741c1.465,1,1.75,3.062,1.9,4.871a35.3,35.3,0,0,0,1.127-9.15A16.864,16.864,0,0,0,342.718,224.232Z",
    transform: "translate(-226.01 -181.421)",
    fill: "#1d1d26"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_449",
    "data-name": "Ellipse 449",
    cx: 26.173,
    cy: 26.173,
    r: 26.173,
    transform: "translate(95.712 184.267)",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28929",
    "data-name": "Path 28929",
    d: "M357.98,479.674a26.88,26.88,0,0,0-4.016.3c-.684.1-1.347.227-2,.384a26.742,26.742,0,0,0-11.336,46.414c.448.378.9.744,1.373,1.093a26.749,26.749,0,1,0,15.983-48.194Zm0,52.347a25.444,25.444,0,0,1-15.122-4.961c-.477-.349-.936-.71-1.384-1.093a25.577,25.577,0,0,1,11.412-44.617c.651-.134,1.3-.238,1.966-.32a25.3,25.3,0,0,1,3.129-.192,25.592,25.592,0,1,1,0,51.183Z",
    transform: "translate(-236.094 -295.99)",
    fill: "#e6e7eb"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28930",
    "data-name": "Path 28930",
    d: "M722.117,554.479H714.64l-3.557-28.84h11.035Z",
    transform: "translate(-307.409 -228.279)",
    fill: "#facca8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28931",
    "data-name": "Path 28931",
    d: "M659.807,554.479H652.33l-3.557-28.84h11.035Z",
    transform: "translate(-280.472 -228.279)",
    fill: "#facca8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28932",
    "data-name": "Path 28932",
    d: "M814.815,735.627H791.822v-.291a8.95,8.95,0,0,1,8.948-8.949h0l4.2-3.186,7.836,3.187h2.007Z",
    transform: "translate(-435.216 -401.627)",
    fill: "#1d1d26"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28953",
    "data-name": "Path 28953",
    d: "M.413,27.86a1.073,1.073,0,0,1-.188-1.5L20.4.414A1.072,1.072,0,1,1,22.09,1.729L1.917,27.672A1.073,1.073,0,0,1,.413,27.86Z",
    transform: "translate(126.122 231.675) rotate(-150)",
    fill: "#e4e4e4"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28933",
    "data-name": "Path 28933",
    d: "M878.815,735.627H855.822v-.291a8.95,8.95,0,0,1,8.948-8.949h0l4.2-3.186,7.836,3.187h2.007Z",
    transform: "translate(-462.884 -401.627)",
    fill: "#1d1d26"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28952",
    "data-name": "Path 28952",
    d: "M.414,27.86a1.073,1.073,0,0,1-.188-1.5L20.4.414A1.072,1.072,0,0,1,22.09,1.73L1.917,27.672A1.073,1.073,0,0,1,.414,27.86Z",
    transform: "translate(124.526 227.762) rotate(-150)",
    fill: "#e4e4e4"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28934",
    "data-name": "Path 28934",
    d: "M809.552,427.053l-11.363,69.192,3.093,10.311-4.058,7.3,5.959,64.132-2.419,5.326,6.759,4.168h13.753l.73-58.059,3.4-8.524v-4.7l6.916-35.4,1.273,49.58,2.012,8.538L833.913,545l2.208,4.259,5.865,39.495h15.421l-1.193-9.188h0a6.791,6.791,0,0,0,3.565-7.515l-.884-4.027,2.012-11.908,3.665-66.433-1.033-53.6-18.04-13.8Z",
    transform: "translate(-437.551 -271.536)",
    fill: "#1d1d26"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28951",
    "data-name": "Path 28951",
    d: "M.413,13.163a1.073,1.073,0,0,1-.188-1.5L8.97.414A1.072,1.072,0,1,1,10.662,1.73L1.917,12.975A1.073,1.073,0,0,1,.413,13.163Z",
    transform: "translate(113.037 218.121) rotate(-150)",
    fill: "#e4e4e4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_219",
    "data-name": "Ellipse 219",
    cx: 14.328,
    cy: 14.328,
    r: 14.328,
    transform: "translate(383.724 39.05)",
    fill: "#facca8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28935",
    "data-name": "Path 28935",
    d: "M801.595,455.888a6.133,6.133,0,0,0-.982-9.352l5.572-21.07-10.734,3.611L791.8,448.531a6.166,6.166,0,0,0,9.79,7.357Z",
    transform: "translate(-434.848 -272.401)",
    fill: "#facca8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M807.475,300.5l-2.3-.478-1.965,1.088s-5.489,7.319-5.489,14.027-6.709,71.356-6.709,71.356l12.2,5.489,9.758-50.62Z",
    transform: "translate(-434.864 -217.994)",
    fill: "#f5f5f5"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M864.481,222.032s3.748-7.164-4.5-7.815c0,0-7.028-6.376-14.192-1.166a7.194,7.194,0,0,0-6.044,4.422s-3.073-1.166-3.749,1.954c0,0-2.249,6.513,0,12.374s3,6.513,3,6.513-3.7-12.289,5.3-12.94,19.06-6.272,19.809.892,1.878,8.929,1.878,8.929S873.1,224.963,864.481,222.032Z",
    transform: "translate(-453.882 -179.16)",
    fill: "#1d1d26"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28936",
    "data-name": "Path 28936",
    d: "M942.75,523.716a4.385,4.385,0,0,1-2.931-1.118L896.458,484a4.422,4.422,0,0,1-.362-6.236l27.777-31.2a4.422,4.422,0,0,1,6.236-.363l43.361,38.6a4.416,4.416,0,0,1,.362,6.235l-27.777,31.2a4.386,4.386,0,0,1-3.043,1.473C942.924,523.714,942.837,523.716,942.75,523.716Z",
    transform: "translate(-479.813 -281.022)",
    fill: "#fff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28937",
    "data-name": "Path 28937",
    d: "M942.534,523.784a4.666,4.666,0,0,1-3.119-1.19L896.054,484a4.707,4.707,0,0,1-.386-6.637l27.777-31.2a4.707,4.707,0,0,1,6.637-.386l43.361,38.6a4.7,4.7,0,0,1,.386,6.637l-27.777,31.2a4.672,4.672,0,0,1-3.239,1.568C942.719,523.781,942.626,523.784,942.534,523.784Zm-15.575-78.068a3.556,3.556,0,0,0-2.665,1.193l-27.777,31.2a3.569,3.569,0,0,0,.292,5.034l43.361,38.6a3.564,3.564,0,0,0,5.034-.293l27.777-31.2a3.565,3.565,0,0,0-.292-5.033l-43.361-38.6A3.551,3.551,0,0,0,926.958,445.716Z",
    transform: "translate(-479.597 -280.806)",
    fill: "#e6e7eb"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28941",
    "data-name": "Path 28941",
    d: "M914.8,457.959a6.133,6.133,0,0,1,3.355-8.785l.037-21.794,9.444,6.251-1.483,19.737a6.166,6.166,0,0,1-11.353,4.591Z",
    transform: "translate(-488.043 -273.235)",
    fill: "#facca8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28956",
    "data-name": "Path 28956",
    d: "M.584,39.348a1.515,1.515,0,0,1-.266-2.124L28.81.585A1.514,1.514,0,1,1,31.2,2.443L2.708,39.082A1.515,1.515,0,0,1,.584,39.348Z",
    transform: "matrix(0.07, -0.998, 0.998, 0.07, 427.022, 228.214)",
    fill: "#e4e4e4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M913.675,308.284l4.219-4.067,3.1,2.237s3.049,3.659,5.489,14.637,0,71.356,0,71.356l-13.417-1.83,1.83-31.714-5.489-26.835Z",
    transform: "translate(-486.049 -219.814)",
    fill: "#f5f5f5"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28942",
    "data-name": "Path 28942",
    d: "M880.428,293.877l-14.215-6.79-9.651-8.951-17.6-.132-5.677,7.38L818.3,290.475l2.5,51.678-1.7,3.974s1.187,1.072,1.729,1.671-.749,5.618-.749,5.618l-.728,5.46,2.019,1.443-2.625,3.1-.652,4.888s45.821-11.389,54.479,7.478c.457,1-.669-8.745-.669-8.745l-1.126-7.132,1.117-6.4,1.7-1.7-2.856-2.856,1.831-13.553Z",
    transform: "translate(-446.572 -208.431)",
    fill: "#1d1d26"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28955",
    "data-name": "Path 28955",
    d: "M.584,39.348a1.515,1.515,0,0,1-.266-2.124L28.81.585A1.514,1.514,0,0,1,31.2,2.443L2.708,39.083A1.516,1.516,0,0,1,.584,39.348Z",
    transform: "matrix(0.07, -0.998, 0.998, 0.07, 431.006, 223.768)",
    fill: "#e4e4e4"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28943",
    "data-name": "Path 28943",
    d: "M347.008,483.365a6.585,6.585,0,0,0-4.827-8.868l-3.158-23.187-9.155,8,4.4,20.791a6.621,6.621,0,0,0,12.738,3.261Z",
    transform: "translate(-235.508 -283.632)",
    fill: "#facca8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1101-2",
    "data-name": "Path 1101",
    d: "M293.093,326.838l-2.482.475-1.5,1.888s-2.427,9.518.338,16.17S312.2,418.885,312.2,418.885l14.356.416-11.183-54.211Z",
    transform: "translate(-217.463 -229.654)",
    fill: "#f5f5f5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28954",
    "data-name": "Path 28954",
    d: "M.584,18.591a1.515,1.515,0,0,1-.266-2.124L12.669.585a1.514,1.514,0,1,1,2.39,1.858L2.708,18.325A1.516,1.516,0,0,1,.584,18.591Z",
    transform: "matrix(0.07, -0.998, 0.998, 0.07, 436.137, 203.23)",
    fill: "#e4e4e4"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28944",
    "data-name": "Path 28944",
    d: "M393.108,476.866a6.585,6.585,0,0,1,1.173-10.029l-5.715-22.692,11.479,4.012,3.667,20.933a6.621,6.621,0,0,1-10.6,7.775Z",
    transform: "translate(-260.884 -280.518)",
    fill: "#facca8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1101-3",
    "data-name": "Path 1101",
    d: "M382.851,309.966l2.48-.484,2.1,1.193s5.8,7.927,5.716,15.13,6.3,76.7,6.3,76.7l-13.165,5.739-9.836-54.471Z",
    transform: "translate(-255.642 -222.119)",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabIllustration);
export default __webpack_public_path__ + "static/media/CollabIllustration.7c86f31af203b5334df74beb7f53b8b8.svg";
export { ForwardRef as ReactComponent };